module.exports = __webpack_public_path__ + "static/media/pro.6b445645.png";